const useCombos = () => {
  const oldestCompletedCombos: string[] = ['e15cc0f7-a3f1-4620-afab-01bba27a8705']

  const newestCompletedCombos: string[] = [
    '51bf3701-8644-46ee-8669-9fe2bb9457c2',
    '1d49d787-4c5b-4e20-b784-d85292ca7a9e',
    '821254f8-63e3-4ccd-bc00-37d695075911',
    'a2d12402-2140-4144-93f1-9db61208749d',
    'ff5ef6e7-6f6f-446b-b479-65798505d03b',
  ]

  const allCompletedCombos = [...oldestCompletedCombos, ...newestCompletedCombos]

  const Complete = {
    values: allCompletedCombos,
    isNewest: (uuid: string) => newestCompletedCombos.includes(uuid),
    isOldest: (uuid: string) => oldestCompletedCombos.includes(uuid),
    isComplete: (uuid: string) => allCompletedCombos.includes(uuid),
  }

  return { Complete }
}

export { useCombos }
